import { Pipe, PipeTransform } from '@angular/core';
import { Content } from '@context/shared/types/common';

@Pipe({
	standalone: true,
	name: 'contentUrl',
})
export class ContentUrlPipe implements PipeTransform {
	transform(content: Content, options?: { asArchived?: boolean }) {
		let prefix = '/home';

		const now = new Date().valueOf();
		const { asArchived } = options ?? {};
		if (
			asArchived ||
			(content.archivedAt && content.archivedAt.toDate().valueOf() < now)
		) {
			prefix = '/archive';
		}

		if (!content.id) return [prefix];
		switch (content.type) {
			case 'file':
				return [prefix, 'file', content.id];
			case 'folder':
				return [prefix, 'folder', content.id];
			default:
				throw new Error(
					`The content type is not supported: ${content.type}`,
				);
		}
	}
}
